import { useEffect } from "react";
import { useRoomContext, useRemoteParticipants } from "@livekit/components-react";
import { useGameStore } from "../../store/gameStore";
import { toast } from "sonner";

// Mounted for EVERY connected client (GM, target, and bystanders alike). Reacts to the shared
// `voiceWhisper` state (relayed over the existing game WebSocket) and locally subscribes/unsubscribes
// from remote audio publications so a GM<->player whisper stays private without touching anyone
// else's ongoing conversation — see LiveKit's client-side selective-subscription pattern.
export default function WhisperControls({ myUserId }) {
  const room = useRoomContext();
  const participants = useRemoteParticipants();
  const whisper = useGameStore((s) => s.voiceWhisper);

  useEffect(() => {
    if (!room) return;
    const active = whisper?.active;
    const isParty = active && (myUserId === whisper.gm_user_id || myUserId === whisper.target_user_id);
    const partnerId = myUserId === whisper?.gm_user_id ? whisper?.target_user_id : whisper?.gm_user_id;
    room.remoteParticipants.forEach((p) => {
      let shouldHear = true;
      if (active) {
        shouldHear = isParty ? p.identity === partnerId : p.identity !== whisper.gm_user_id && p.identity !== whisper.target_user_id;
      }
      p.audioTrackPublications.forEach((pub) => {
        try { pub.setSubscribed(shouldHear); } catch { /* track may not be ready yet */ }
      });
    });
  }, [whisper, participants, room, myUserId]);

  useEffect(() => {
    if (whisper?.active && myUserId === whisper.target_user_id) {
      toast.info("The GM is whispering to you privately");
    }
  }, [whisper?.active, whisper?.target_user_id, myUserId]);

  return null;
}
